<p-dialog [resizable]="false" [draggable]="false"
  [visible]="visible()"
  [modal]="true"
  [style]="{ width: 'min(840px, 94vw)' }"
  [header]="'Make subscription' | translate"
  (visibleChange)="visible.set($event)"
>
  <div class="subscription-form">
    <msf-input
      [model]="name()"
      (modelChange)="setName($event)"
      [label]="'Name'"
    ></msf-input>
    @if (visible()) {
      <app-quartz-schedule-fields
        (validChange)="scheduleValid.set($event)"
        [cronExpression]="cronExpression()"
        (cronExpressionChange)="setCronExpression($event)"
        [timeZoneId]="timeZoneId()"
        (timeZoneIdChange)="setTimeZoneId($event)"
      ></app-quartz-schedule-fields>
    }
  </div>
  <ng-template #footer>
    <app-secondary-button title="Cancel" (action)="close()"></app-secondary-button>
    <app-primary-button
      title="Create subscription"
      icon="pi pi-calendar-plus"
      [loading]="saving()"
      [disable]="!canSave()"
      (action)="save()"
    ></app-primary-button>
  </ng-template>
</p-dialog>
